import './styles.scss'
import React from 'react'
import { Dialog } from 'primereact/dialog'

const DialogUIModal = (props) => {
  const { visible, onHide, header, body, footer, className = 'custom-modal', size = 'md', closable = true, focusOnShow = true, maximizable = false, position = 'center' } = props

  const dialogSizeClass = `p-dialog-${size}`

  return (
    <Dialog header={header} visible={visible} onHide={onHide} footer={footer} className={`custom-dialog ${dialogSizeClass} ${className}`} maximizable={maximizable} position={position} closable={closable} focusOnShow={focusOnShow}>
      {body()}
    </Dialog>
  )
}

export default DialogUIModal
